

<!-- <ion-header>
  <ion-toolbar style="background-color: red;">
    <ion-title>History Of STT Model Inferencing</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header> -->


<ion-header>
  <ion-toolbar style="background-color: red;">
    <ion-title>Classification Model Inferencing History</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal('close')">
        <ion-icon name="close" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>

  <ion-row style="background-color: #f1f1f1;">
    
    <ion-col size="2" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-label position="floating">Filter User</ion-label>
              <ion-select [(ngModel)] = "selectedOptionUser" (ionChange)="onOptionChangeForUser($event)">
                <ion-select-option *ngFor="let option of optionsUser" [value]="option.value">
                  {{ option.label }}
                </ion-select-option>
        </ion-select>
      </ion-item>
    </ion-col>

    <ion-col size="4" style="display: revert;padding:0px 10px"></ion-col>


    <ion-col size="3" style="display: revert;padding:0px 10px">
      <ion-item>
        <ion-input [(ngModel)]="searchQuery" (ionInput)="onSearchInputChange()" (keyup.enter)="onSearch()" placeholder="Search..."></ion-input>
        <ion-icon class="search-icon" name="search" slot="end" title="search" (click)="onSearch()"></ion-icon>
        <ion-icon name="close-circle" slot="end" *ngIf="searchQuery"  (click)="clearSearch()"></ion-icon>
      </ion-item>      
    </ion-col>   

  </ion-row>
</ion-header>

  
<ion-content class="no-hover-page" [fullscreen]="true">
  <div class="scroll-container" style="overflow-x: auto; width: 100%;">
    <ng-container>
        <ion-grid style="padding-bottom: 95px; min-width: 1700px;">
        <!-- <ion-grid style="padding-bottom: 95px;"> -->
          <!-- Table Header Row -->
          <ion-row class="table-header">
            <ion-col size="1"><strong>Index</strong></ion-col>
            <ion-col size="2"><strong>Question</strong></ion-col>
            <ion-col size="2"><strong>User Response</strong></ion-col>
            <ion-col size="2"><strong>Model Response</strong></ion-col>
            <ion-col size="2"><strong>Correct Answer</strong></ion-col>
            <ion-col size="1"><strong>User</strong></ion-col>
            <ion-col size="1"><strong>Actions</strong></ion-col>
            <ion-col size="1"><strong>Model Name</strong></ion-col>
          </ion-row>
        
          <!-- Data Rows -->
          <ion-row *ngFor="let item of historyData; let i = index" class="table-row">
            <ion-col size="1">{{ i + 1 }}</ion-col>
        
          

            <ion-col size="2">
              <div>
                <p>{{ item.question }}</p>
              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.user_answer }}</p>
              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.predicted_answer }}</p>
                <p>{{ item.predicted_answer?.trim() !== '' ? (item.confidence_score * 100 | number:'1.2-2') + '%' : ' ' }}</p>
              </div>
            </ion-col>
            <ion-col size="2">
              <div>
                <p>{{ item.corrected_answer }}</p>
              </div>
            </ion-col>
            <ion-col size="1">
              <p>{{ item.user }}</p>
            </ion-col>
            
            
            
        
            <ion-col size="1">
              <div class="tooltip-wrapper">
                <ion-button class="zoom-icon-button" fill="clear" color="primary" (click)="deleteData(item)">
                  <ion-icon slot="icon-only" name="trash-outline" ></ion-icon>
                </ion-button>
                <span class="custom-tooltip">Delete Data</span>
              </div>
            </ion-col>

            <ion-col size="1">
              <div>
                <p>{{ item.model_name }}</p>
              </div>
            </ion-col>

          </ion-row>
        
          <!-- Empty State -->
          <ion-row *ngIf="historyData.length === 0">
            <ion-col>
              <p>No history found.</p>
            </ion-col>
          </ion-row>
        </ion-grid>
        
        

    </ng-container>
  </div>
  
</ion-content>

<ion-footer class="pagination-footer">
  <ion-toolbar>
    <ion-row class="pagination-row">
      <!-- First & Previous Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === 1" (click)="goToFirstPage()">
          <ion-icon name="play-back-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === 1" (click)="prevPage()">
          <ion-icon name="chevron-back-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Page Number Display -->
      <ion-col size="auto" class="text-center">
        <ion-item lines="none">
          <span>{{ currentPage }} / {{ totalPages }}</span>
        </ion-item>
      </ion-col>

      <!-- Next & Last Page Buttons -->
      <ion-col size="auto">
        <ion-button [disabled]="currentPage === totalPages" (click)="nextPage()">
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
        <ion-button [disabled]="currentPage === totalPages" (click)="goToLastPage()">
          <ion-icon name="play-forward-outline"></ion-icon>
        </ion-button>
      </ion-col>

      <!-- Go to Specific Page Input -->
      <ion-col size="auto">
        <ion-item lines="none">
          <ion-input type="number" [(ngModel)]="currentPage" placeholder="Page #" min="1" [max]="totalPages"></ion-input>
        </ion-item>
      </ion-col>
      <ion-col size="auto">
        <ion-button [disabled]="!currentPage || currentPage < 1 || currentPage > totalPages" 
                    (click)="goToSpecificPage(currentPage)">
          GO
        </ion-button>
      </ion-col>

      <!-- Page Size Selector -->
      <ion-col size="auto">
        <ion-item>
          <!-- <ion-label>Page Size</ion-label> -->
          <ion-select [(ngModel)]="pageSize" (ionChange)="onPageSizeChange()">
            <ion-select-option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</ion-select-option>
          </ion-select>
        </ion-item>
      </ion-col>


    </ion-row>
  </ion-toolbar>
</ion-footer>
    



  



